"use client";

import React, { useEffect, useRef, useState } from "react";
import { Database, ShieldCheck, Send, Cpu, Code, Terminal } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const steps = [{
  id: "step-1",
  title: "Professionnalisme & Rigueur",
  description: "Une méthodologie d'intervention structurée, alliant expertise technique et respect des normes qualité les plus exigeantes du secteur.",
  icon: ShieldCheck,
  codeTitle: "audit_methodologie.json",
  code: `{
  "engagement": "Qualité Totale",
  "norme_reference": "Qualiopi_V7",
  "process": {
    "diagnostic": "Analyse_besoins_360",
    "ingenierie": "Sur_mesure",
    "evaluation": "Indicateurs_performance"
  },
  "statut": "Conformité_Validée"
}`
}, {
  id: "step-2",
  title: "Co-construction & Pédagogie",
  description: "Nous bâtissons vos solutions ensemble, en vulgarisant la complexité juridique pour favoriser l'appropriation par vos équipes.",
  icon: Cpu,
  codeTitle: "atelier_co-design.log",
  code: `> [INIT] Session de co-construction... OK
> [INFO] Analyse du cadre juridique local...
> [ACTION] Traduction opérationnelle des textes...
> [SYNC] Alignement objectifs vs contraintes...
> [SUCCESS] Livrable partagé généré
> [READY] Etape d'implémentation activée`
}, {
  id: "step-3",
  title: "Orientation Résultats & RSE",
  description: "Des actions concrètes mesurables, intégrant les enjeux d'éthique et de responsabilité sociétale pour un impact durable.",
  icon: Send,
  codeTitle: "impact_durable.ts",
  code: `async function evaluerImpact(projetId: string, ctx: Context) {
  const indicateurs = {
    id: projetId,
    performance: await calculerROI(ctx),
    conformite: verifyLegalCompliance(ctx.regulations),
    impact_rse: evaluateSocialContribution(ctx.data)
  };

  const rapport = await generateur.final(indicateurs);
  
  if (rapport.score >= 0.95) {
    return { success: true, label: "Excellence Opérationnelle" };
  }
}`
}];
export default function AutomationDeepDive() {
  const sectionRef = useRef<HTMLElement>(null);
  const [progress, setProgress] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const section = sectionRef.current;
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const startOffset = windowHeight * 0.2;
      const scrolled = scrollY - sectionTop + startOffset;
      const scrollableHeight = sectionHeight - windowHeight * 0.5;
      let newProgress = scrolled / scrollableHeight * 100;
      newProgress = Math.max(0, Math.min(100, newProgress));
      setProgress(newProgress);
      const stepThreshold = 100 / steps.length;
      const currentStep = Math.min(steps.length - 1, Math.floor(newProgress / stepThreshold));
      setActiveStep(currentStep);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return;
}